<template>
  <div class="pack-list">
    <PackListItem v-for="pack in packs" :item="pack" :key="pack.id" />
    <template v-if="loading">
      <PackListItemSkeleton v-for="number in 20" :key="number" />
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import PackListItem from './pack-list-item';
import PackListItemSkeleton from './pack-list-item-skeleton';
import { debounce } from 'debounce';

export default defineComponent({
  name: 'PackList',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {
      prevScrollTop: 0,
    };
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      loading: 'pack/index/loading',
      packs: 'pack/index/packs',
      hasMore: 'pack/index/hasMore',
    }),
  },

  /**
   * 已创建
   */
  async created() {
    this.resetPacks();

    try {
      this.getPacks();
    } catch (error) {
      this.pushMessage({ content: '出问题了' });
    }

    if (window) {
      window.addEventListener('scroll', this.onScrollWindow);
      window.scrollTo({ top: 0 });
    }
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapActions({
      getPacks: 'pack/index/getPacks',
      pushMessage: 'notification/pushMessage',
    }),

    ...mapMutations({
      resetPacks: 'pack/index/resetPacks',
    }),

    onScrollWindow() {
      this.debounceLoadMore();
    },

    debounceLoadMore: debounce(function() {
      if (document) {
        const {
          scrollTop,
          scrollHeight,
          clientHeight,
        } = document.documentElement;

        const height = clientHeight + scrollTop + 900;
        const touchDown = scrollHeight - height < 0;
        const scrollDown = scrollTop > this.prevScrollTop;

        if (touchDown && scrollDown && !this.loading && this.hasMore) {
          this.getPacks();
        }

        this.prevScrollTop = scrollTop;
      }
    }, 100),
  },

  /**
   * 使用组件
   */
  components: {
    PackListItem,
    PackListItemSkeleton,
  },
});
</script>

<style scoped>
@import './styles/pack-list.css';
</style>
